import { useAppSelector } from '../../../../store/hooks'
import { Delta1EditorDumb } from './dumb'

export const Delta1Editor = () => {
  const state = useAppSelector(state => state.strategy.selectedStrategy.delta1)

  return <Delta1EditorDumb fees={state.fees} />
}
